/* @flow strict */

import * as React from 'react';
import {
  RoutesType
} from 'client/src/routes';
import PaymentStripe from './index';

export const PaymentRoutes: RoutesType = [{
  Component: PaymentStripe,
  params: {
    path: '/payment/stripe/oauth2/callback'
  }
}];
